export class RankingModel {
    constructor(rank, index = 0, quarter, userId) {
        this.id = rank?.user_id
        this.userId = rank?.user_id + 100000
        this.rankType = this.getRank(index + 1)
        this.rank = index + 1
        this.avatar = rank?.user?.avatar
        this.name = rank?.user?.name ?? ''
        this.department = rank?.department?.name ?? ''
        this.level = rank?.current_level?.level
        this.score = rank?.total ? Math.floor(rank?.total) : 0
        this.myRank = this.getMyRank(rank?.rank)
        this.highlighted = rank?.user_id + 100000 === userId
    }
    getRank(index) {
        if (index < 10){
            return `0${index}`
        }
        return index
    }
    getMyRank(rank) {
        if (rank < 10){
            return `0${rank}`
        }
        return rank
    }
}
